import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { MarkdownContainer } from 'ui/LangFlowChat/components/LangflowMessages/MarkdownContainer/MarkdownContainer';

import './MarkdownFormattedText.scss';
interface MarkdownFormattedTextProps {
  text: string;
  className?: string;
}

const MarkdownFormattedText: React.FC<MarkdownFormattedTextProps> = ({ text, className = '' }) => {
  const formattedText = text.replaceAll(/\\n/g, '\n');
  return (
    <div className={`markdown-content ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          table: ({ children }) => (
            <MarkdownContainer element="table">
              <table>{children}</table>
            </MarkdownContainer>
          ),
          pre: ({ children }) => (
            <MarkdownContainer element="pre">
              <pre>{children}</pre>
            </MarkdownContainer>
          ),
        }}
      >
        {formattedText}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownFormattedText;
